

/**
 * 复制元素
 *
 * @param copyIndex 被复制的元素索引值
 * @param id 新元素id
 * @param index 新元素索引值
 * @param copyClassName 被复制的元素类名
 * @returns {null|*|jQuery}
 */
function copyDivByClassName(copyIndex, id, index, copyClassName) {

    if ($("." + copyClassName).eq(copyIndex) != null && $("." + copyClassName).eq(copyIndex).length <= 0) {
        return null;
    }

    var node = $("." + copyClassName).eq(copyIndex).clone(true);
    node.attr('id', id);
    node.attr('data-index', index);
    return node;
}

/**
 * 复制元素
 *
 * @param copyIndex 被复制的元素索引值
 * @param id 新元素id
 * @param index 新元素索引值
 * @param copyClassName 被复制的元素类名
 * @param parentId 被复制的元素父级id
 * @returns {null|*|jQuery}
 */
function copyDivByParentId(copyIndex, id, index, copyClassName, parentId) {

    if ($("#" + parentId + " ." + copyClassName).eq(copyIndex) != null && $("." + copyClassName).eq(copyIndex).length <= 0) {
        return null;
    }

    var node = $("#" + parentId + " ." + copyClassName).eq(copyIndex).clone(true);
    node.attr('id', id);
    node.attr('data-index', index);

    return node;
}

/**
 * 复制元素 DragImageBlock 特用
 *
 * @param copyIndex 被复制的元素索引值
 * @param id 新元素id
 * @param index 新元素索引值
 * @param copyClassName 被复制的元素类名
 * @param parentId 被复制的元素父级id
 * @returns {null|*|jQuery}
 */
function copyDivByParentIdDragImageBlock(copyIndex, id, index, copyClassName, parentId, typeIndex) {
    if ($("#" + parentId + " ." + copyClassName).eq(copyIndex) != null && $("." + copyClassName).eq(copyIndex).length <= 0) {
        return null;
    }

    var node = $("#" + parentId + " ." + copyClassName).eq(copyIndex).clone(true);
    node.attr('id', id);
    node.attr('data-index', index);
    node.children('.productImgDiv').children('.dragProductImage').attr('id', "dragProductImage-" + typeIndex + '-' + index);
    node.children('.productTitleDiv').children('.heading').attr('id', "dragProductHeading-" + typeIndex + '-' + index);
    node.children('.productPriceDiv').children('.preferentialPrice').children().attr('id', "preferentialPrice-" + typeIndex + '-' + index);
    node.children('.productPriceDiv').children('.originalPrice').children().attr('id', "originalPrice-" + typeIndex + '-' + index);
    node.children('.productVariantsDiv').children('.productVariants').attr('id', 'productVariants-' + typeIndex + '-' + index);
    node.children('.productVariantsDiv').children('.productVariants').attr('data-type', typeIndex);
    node.children('.productVariantsDiv').children('.productVariants').attr('data-index', index);
    node.children('.productAddCartDiv').children('.dragImageAddCartFrom').children('.fromVariantId').attr('id', 'dragImageVariantId-' + typeIndex + '-' + index);

    return node;
}


/**
 * 粘贴到指定元素指定方向
 * @param direction
 * @param affixClassName
 */
function appendDivByClassName(direction, affixClassName, node) {

    if (direction == "before") {
        $("." + affixClassName).append(node);
    } else {
        $("." + affixClassName).prepend(node);
    }
}

/**
 * 粘贴到指定元素指定方向
 * @param direction
 * @param affixId
 */
function appendDivById(direction, affixId, node) {
    if (direction == "before") {
        $("#" + affixId).append(node);
    } else {
        $("#" + affixId).prepend(node);
    }
}

/**
 * 休眠
 * @param ms
 * @returns {Promise<unknown>}
 */
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * jquery设置cookie
 * @param key
 * @param value
 * @param expires
 */
function jqSetCookie(key, value, expires) {
    $.cookie(key, value, { expires: expires, path: '/' })
}

/**
 * 去除过期的商品数据
 * @param data 数组
 */
function removeExpiredProductData(data) {
    var newData = [];
    for (var i = 0; i < data.length; i++) {
        var differValue = calculateIntervalTime(new Date().getTime(), data[i].saveDate);
        if (differValue <= 24) {
            newData.push(data[i]);
        }
    }


    return newData;
}

/**
 * @param currentTime 当前时间时间戳
 * @param appointTime 旧时间时间戳
 * @type {Date}
 */
function calculateIntervalTime(currentTime, appointTime) {

    //返回小时
    var differValue = (currentTime - appointTime);
    var h = differValue / (60 * 60 * 1000)
    return h;
}

/**
 * 根据产品句柄获取产品信息
 * @param handle
 */
function getProductInfo(handle) {
    var result;
    $.ajax({
        type: 'get',
        async: false,
        url: '/products/' + handle + '.js',
        success: function (d) {
            result = JSON.parse(d);
        }
    });
    return result;
}

//

/**
 * graphQL请求
 */
async function graphQLUtils(data) {

    const STOREFRONT_ACCESS_TOKEN = 'ea2204ea154019703128af6f4b4f7188'
    const GRAPHQL_URL = '/api/2024-07/graphql.json'
    $.ajax({
        url: GRAPHQL_URL,
        type: "POST",
        async: false,
        contentType: 'application/graphql',
        headers: {
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
        },
        data: data,
        dataType: 'json', // 预期服务器返回的数据类型
        success: function (result) {
            console.log('resultttt', result)
            return result;
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.error('请求失败: ' + textStatus, errorThrown);
        }
    });
}

/**
 * 收缩展开
 * @param targetId 目标id
 * @param arrowId 箭头id
 */
function slideUpDown(targetId, arrowId) {


    // 箭头旋转 目标块收缩展开
    if ($("#" + arrowId).css('transform') === 'matrix(1, 0, 0, 1, 0, 0)' || $("#" + arrowId).css('transform') === null) {
        $("#" + arrowId).css('transform', 'rotate(180deg)');
        $('#' + targetId).slideUp(300);
    } else {
        $("#" + arrowId).css('transform', 'rotate(0deg)');
        $('#' + targetId).slideDown(300);
    }


}

/**
 * 播放或暂停 视频(切换)
 * @param id 视频id
 * @param buttonId 按钮id
 */
function videoPlayOrPause(id, buttonId) {
    var video = document.getElementById(id);
    var videoButton = $("#" + buttonId);

    if (video.paused) {
        // 暂停状态
        videoButton.fadeOut();
        video.play();
        video.controls = true;
    } else {
        // 播放状态
        videoButton.fadeIn();
        video.pause();
        video.controls = false;
    }
}

/**
 * 暂停视频
 * @param className
 * @param buttonId
 */
function videoListPause(className, buttonId) {
    var videos = document.querySelectorAll("." + className);
    var videoButton = $("#" + buttonId);
    videos.forEach(function (video) {
        if (video instanceof HTMLMediaElement) {
            video.pause();
            videoButton.fadeIn();
        }
    });
}

/**
 * 设置swiper下的div的高相同
 * @param className
 */
function setSwiperContentHeight(className) {

    const contentDivs = document.querySelectorAll('.' + className);

    contentDivs.forEach(div => {
        div.style.height = 'auto';
    })
    // 找到最大高度
    let list = []
    contentDivs.forEach(div => {
        const height = div.offsetHeight;
        list.push(parseInt(height))
    })

    var maxHeight = Math.max(...list)

    // console.log(maxHeight)

    // 设置所有 content div 的高度为最大高度
    contentDivs.forEach(div => {
        div.style.height = maxHeight + 'px';
    });
}

/**
 * 排序 所有产品页
 * @param sortFlag
 * @param className
 */
function sortByPrice(sortFlag, className) {
    let productDiv = $("." + className);
    // 选择所有的产品 DIV
    let productDivList = productDiv.get(); // 转换为普通数组

    // 对数组进行排序
    productDivList.sort((a, b) => {
        // 获取 data-price 属性值并转换为数字
        let priceA = parseFloat($(a).attr('data-price'));
        let priceB = parseFloat($(b).attr('data-price'));
        let creatDateA = new Date($(a).attr('data-created'));
        let creatDateB = new Date($(b).attr('data-created'));
        if (sortFlag === 'ascByPrice') {
            return priceA - priceB; // 按价格升序排序
        } else if (sortFlag === 'descByPrice') {
            return priceB - priceA; // 按价格降序排序
        } else if (sortFlag === 'descByCreatTime') {
            // 按创建时间降序排序
            if (creatDateB >= creatDateA) {
                return 1;
            } else {
                return -1;
            }
        }

    });

    // 将排序后的元素重新添加到 DOM
    let container = productDiv.parent(); // 父级元素
    productDivList.forEach(item => {
        container.append(item); // 重新添加到父元素
    });
}

/**
 * 显隐产品块
 * @param radioName
 * @param targetClassName
 */
function filterChangeCenter(radioName, targetClassName) {
    // 产品系列筛选
    let allProductBlockList = $("." + targetClassName).toArray();
    let collectionType = $('input[name="' + radioName + '"]:checked').val() ? $('input[name="' + radioName + '"]:checked').val() : 'all';
    let showBlockList = allProductBlockList.filter(function (e) {
        if (collectionType !== 'all') {
            return $(e).attr('data-collection') === collectionType;
        } else {
            return true;
        }
    })
    // 显隐
    $("." + targetClassName).css('display', 'none');
    showBlockList.forEach(function (item, index) {
        $(item).css('display', 'flex');
    });
}

/**
 * 文件下载
 * @param pdfUrl
 */
function downloadPDF(pdfUrl) {
    fetch(pdfUrl)
        .then(response => response.blob())
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('PDF下载失败:', error);
        });
}

/**
 * 为视频添加加载动画
 * @param videoParentId 视频标签的父级class
 */
async function videoLoadingAnimation(videoParentClassName) {

    $("." + videoParentClassName).each(function () {
        let self = $(this);
        let videoLength = self.find('video').length;

        const video = self.find('video');
        const loader = self.find('.video-loader');
        const videoPreview = loader.find('.video-preview');

        $(video).on('canplaythrough', function () {
            loader.css('display', 'none');
            video.css('display', 'flex');
        });

        video.on('waiting', function () {
            loader.css('display', 'flex');
        });

        video.on('playing', function () {
            loader.css('display', 'none');
        });
    })

}

/**
 * 阻止视频点击默认事件
 * @param e
 */
function videoPreventClick(e) {
    e.preventDefault();
}

/**
 * 监听组件是否进入视口
 * @param selector
 * @param onEnter
 * @param onExit
 */
function observeVisibility($elements, onEnter, onExit, threshold) {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                onEnter(entry.target); // 当元素进入视口时调用
            } else {
                onExit(entry.target); // 当元素离开视口时调用
            }
        });
    }, {
        threshold: threshold // 设置进入视口的比例阈值
    });


    $elements.each(function () {
        observer.observe(this); // 观察每个 jQuery 对象中的 DOM 元素
    });
}

/**
 * 切换点击状态(展开收起 子元素)
 * @param className
 * @param dom
 * @param activeClassName
 * @param slideDom
 * @param index
 */
function clickChangeActive(className, dom, activeClassName, slideDom, index) {

    // 1.查找是否已为激活状态
    var flag;
    if ($(dom).find("." + className).hasClass(activeClassName)) {
        flag = true;
    } else {
        flag = false;
    }

    // 2.移除元素className
    $("." + className).removeClass(activeClassName);

    // 3.添加元素className
    if (!flag) {
        $(dom).find("." + className).addClass(activeClassName);
    }

    // 4.全部收缩
    $("." + slideDom).slideUp();
    if (!flag) {
        $("#" + slideDom + "-" + index).slideDown();
    }

}

/**
 * 切换点击状态(切换图片)
 * @param clickDom
 * @param className
 * @param activeClassName
 * @param changeClassName
 * @param index
 */
function clickChangeActivePicture(clickDom, className, activeClassName, changeClassName, index) {

    // 1.移除元素className
    $("." + className).removeClass(activeClassName);

    // 2.添加元素className
    $(clickDom).addClass(activeClassName);

    // 3.切换图片
    $("." + changeClassName).css("display", 'none');
    $("#" + changeClassName + "-" + index).css("display", 'flex');

}

/**
 * 切换点击状态(展开收起)
 * @param clickDom
 * @param className
 * @param activeClassName
 * @param changeClassName
 * @param index
 */
function clickChangeActiveSlide(clickDom, className, activeClassName, changeClassName, index) {

    // 1.查找是否已为激活状态
    var flag;
    if ($(clickDom).hasClass(activeClassName)) {
        flag = true;
    } else {
        flag = false;
    }

    // 2.移除元素className
    $("." + className).removeClass(activeClassName);

    // 3.添加元素className
    if (!flag) {
        $(clickDom).addClass(activeClassName);
    }

    // 4.全部收缩
    $("." + changeClassName).slideUp();
    if (!flag) {
        $("#" + changeClassName + "-" + index).slideDown();
    }

}